import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/zones`;

export const getZones = () => axios.get(API);

export const createZone = (data) => axios.post(API, data);

export const updateZone = (id, data) => axios.patch(`${API}/${id}`, data);

export const deleteZone = (id) => axios.delete(`${API}/${id}`);
